import styled from 'foundations-theming/utils';
const SystemMessageEndContent = styled.div.withConfig({
  displayName: "SystemMessageEndContent",
  componentId: "iqwy9i-0"
})(["display:flex;flex-direction:column;align-items:flex-end;justify-content:center;font-size:", ";color:", ";white-space:nowrap;"], ({
  theme
}) => theme.space[300], ({
  theme
}) => theme.color['text-core-subtle']);
export default SystemMessageEndContent;